import { useEffect, useRef } from "react";

// Global flag to track if Beacon has been initialized
let isBeaconInitialized = false;

export function useBeacon(apiKey: string) {
  const scriptLoadedRef = useRef(false);

  // 1) stub the window.Beacon queue before loading
  useEffect(() => {
    if (!apiKey || window.Beacon) return;

    const stub = ((method: string, options?: string, data?: unknown) => {
      stub.readyQueue.push({ method, options, data });
    }) as {
      (method: string, options?: string, data?: unknown): void;
      readyQueue: Array<{ method: string; options?: string; data?: unknown }>;
    };

    stub.readyQueue = [];
    window.Beacon = stub;
  }, [apiKey]);

  // 2) Check if script is already loaded before using useScript
  useEffect(() => {
    if (!apiKey) return;

    // Check if script is already loaded
    const existingScript = document.querySelector('script[src="https://beacon-v2.helpscout.net"]');
    if (existingScript || scriptLoadedRef.current) {
      // Script already loaded, just initialize if needed
      if (window.Beacon && !isBeaconInitialized) {
        try {
          window.Beacon("init", apiKey);
          isBeaconInitialized = true;
        } catch (error) {
          console.error("Failed to initialize Beacon:", error);
        }
      }
      return;
    }

    // Load the script only if not already loaded
    const script = document.createElement("script");
    script.src = "https://beacon-v2.helpscout.net";
    script.async = true;
    script.onload = () => {
      scriptLoadedRef.current = true;
      if (apiKey && window.Beacon && !isBeaconInitialized) {
        try {
          window.Beacon("init", apiKey);
          isBeaconInitialized = true;
        } catch (error) {
          console.error("Failed to initialize Beacon:", error);
        }
      }
    };
    script.onerror = () => {
      console.error("Failed to load Beacon script");
    };

    document.body.appendChild(script);
  }, [apiKey]);
}
